import { useCallback, useEffect } from 'react';
import useTask from '../../../../modules/tasks/hooks/use-task';
import img from '../../../../assets/t-204/drzewko2.jpg';
import imgBig from '../../../../assets/t-204/drzewko-big2.jpg';
import ImageView from '../../../image-view';
import './style.scss';
import QuestionBox from '../../../question-box';
import DownloadButton from '../../../download-button';

type Props = {
    onComplete?: () => void
}

const Task204: React.FC<Props> = ({ onComplete: completeCallback }) => {

    const onComplete = useCallback(() => {
        if (completeCallback) {
            completeCallback();
        }
    }, [completeCallback]);

    const { task } = useTask('t-204');

    useEffect(() => {
        onComplete();
    }, [onComplete])

    return <div className="task task-204">
        <h2>zadanie 4</h2>
        <h3>{task?.title}</h3>
        <p>
            Zastanawialiście się kiedyś co by się stało, gdyby Wendy nie poleciała z Piotrusiem Panem do Nibylandii? Albo gdyby Ania Shirley jednak nie została adoptowana przez Marylę i Mateusza? Jak potoczyłyby się ich losy? Niestety (a może i na szczęście!) nigdy się tego nie dowiemy. W klasycznych książkach my, jako czytelnicy, jesteśmy bierni - śledzimy opowieść, ale nie mamy żadnego wpływu na jej przebieg. Inaczej ma się sytuacja w grach paragrafowych. Są to książki, w których to my decydujemy, jak potoczą się losy głównej postaci.
        </p>
        <p className="instruction">
            <strong>Zadanie:</strong>  Oto schemat krótkiej gry paragrafowej. Przeczytajcie ją i stwórzcie własne rozgałęzienie tam, gdzie widać znaki zapytania.
        </p>
        <div className="image">
            <ImageView src={imgBig} preview={img} />
            <DownloadButton src={imgBig} file='drzewko.jpg' />
        </div>
        <QuestionBox>
            <p>
                A może Wasi domownicy dopiszą dalszą część? Dajcie się ponieść fantazji!
            </p>
        </QuestionBox>
    </div>
}

export default Task204;
